import { useContext } from 'react';
import { NotificationContext } from './notificationContext';

export function useNotification() {
    const notificationContext = useContext(NotificationContext);
    if (!notificationContext) {
        throw new Error('useNotification must be wrapped in a NotificationProvider');
    }
    return notificationContext;
}
